/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCouriersReport200ResponseValueTabsInner
 */
export interface GetCouriersReport200ResponseValueTabsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCouriersReport200ResponseValueTabsInner
     */
    code: string;
    /**
     * 
     * @type {Date}
     * @memberof GetCouriersReport200ResponseValueTabsInner
     */
    creationTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetCouriersReport200ResponseValueTabsInner
     */
    closeTime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetCouriersReport200ResponseValueTabsInner
     */
    paymentMethod: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCouriersReport200ResponseValueTabsInner
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof GetCouriersReport200ResponseValueTabsInner
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCouriersReport200ResponseValueTabsInner
     */
    pending: boolean;
}

/**
 * Check if a given object implements the GetCouriersReport200ResponseValueTabsInner interface.
 */
export function instanceOfGetCouriersReport200ResponseValueTabsInner(value: object): value is GetCouriersReport200ResponseValueTabsInner {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('closeTime' in value) || value['closeTime'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    return true;
}

export function GetCouriersReport200ResponseValueTabsInnerFromJSON(json: any): GetCouriersReport200ResponseValueTabsInner {
    return GetCouriersReport200ResponseValueTabsInnerFromJSONTyped(json, false);
}

export function GetCouriersReport200ResponseValueTabsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCouriersReport200ResponseValueTabsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'creationTime': (new Date(json['creationTime'])),
        'closeTime': (json['closeTime'] == null ? null : new Date(json['closeTime'])),
        'paymentMethod': json['paymentMethod'],
        'address': json['address'],
        'total': json['total'],
        'pending': json['pending'],
    };
}

export function GetCouriersReport200ResponseValueTabsInnerToJSON(json: any): GetCouriersReport200ResponseValueTabsInner {
    return GetCouriersReport200ResponseValueTabsInnerToJSONTyped(json, false);
}

export function GetCouriersReport200ResponseValueTabsInnerToJSONTyped(value?: GetCouriersReport200ResponseValueTabsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'creationTime': ((value['creationTime']).toISOString()),
        'closeTime': (value['closeTime'] == null ? null : (value['closeTime'] as any).toISOString()),
        'paymentMethod': value['paymentMethod'],
        'address': value['address'],
        'total': value['total'],
        'pending': value['pending'],
    };
}

